import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import UserListLayer from "../components/UserListLayer";

const UserListPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle='Users'>

        {/* BlankPageLayer */}
        <UserListLayer />
      </MasterLayout>
    </>
  );
};

export default UserListPage;